import React, { FC } from 'react';
import { SatisfactionRatingIconsProps } from './SatisfactionRatingIconsProps';
import { Stack } from '@mui/material';
import feedbackSad from '@ingka/ssr-icon/paths/feedback-sad';
import feedbackDissatisfied from '@ingka/ssr-icon/paths/feedback-dissatisfied';
import feedbackNeutral from '@ingka/ssr-icon/paths/feedback-neutral';
import feedbackSatisfied from '@ingka/ssr-icon/paths/feedback-satisfied';
import feedbackHappy from '@ingka/ssr-icon/paths/feedback-happy';
import Text from '@ingka/text';
import Pill from '@ingka/pill';
import FormField from '@ingka/form-field';

const pills = [
  { icon: feedbackSad, value: 1 },
  { icon: feedbackDissatisfied, value: 2 },
  { icon: feedbackNeutral, value: 3 },
  { icon: feedbackSatisfied, value: 4 },
  { icon: feedbackHappy, value: 5 },
];
const SatisfactionRatingIcons: FC<SatisfactionRatingIconsProps> = ({
  selectedIcon,
  setSelectedIcon,
}) => {
  return (
    <Stack>
      <FormField
        valid={selectedIcon !== -1}
        shouldValidate
        validation={{ msg: 'Select a rating to continue' }}
      >
        <Stack flexDirection={'row'} justifyContent={'space-between'}>
          {pills.map((pill) => (
            <Pill
              trailingIcon={pill.icon}
              onClick={() => setSelectedIcon(pill.value)}
              selected={pill.value === selectedIcon}
            />
          ))}
        </Stack>

        <Stack justifyContent={'space-between'} mt={2} flexDirection={'row'}>
          <Text tagName="p" textStyle="Body.S">
            Very poor
          </Text>
          <Text tagName="p" textStyle="Body.S">
            Excellent
          </Text>
        </Stack>
      </FormField>
    </Stack>
  );
};

export default SatisfactionRatingIcons;
